import { OmitStrict } from 'type-zoo/types';

import { ButtonProps } from '@dansk-metal/ui';

import { EventDto } from '@web/services/crm-api/rest';

import { ContentDrawer, ContentDrawerProps } from '../content-drawer/content-drawer';

import { RegistrationConfirmation } from './event-registration-confirmation';
import { RegistrationForm, RegistrationFormProps } from './event-registration-form';

export type RegistrationDrawerProps = {
	drawer: OmitStrict<ContentDrawerProps, 'children'>;
	form: RegistrationFormProps;
	showConfirmation: boolean;
	event: EventDto;
	userEventsUrl: string;
};

export function RegistrationDrawer({
	drawer,
	form,
	showConfirmation,
	event,
	userEventsUrl,
}: RegistrationDrawerProps) {
	return (
		<ContentDrawer {...drawer}>
			{showConfirmation ? (
				<RegistrationConfirmation event={event} onClose={drawer.onClose as ButtonProps['onClick']} userEventsUrl={userEventsUrl} />
			) : (
				<RegistrationForm {...form} />
			)}
		</ContentDrawer>
	);
}
